import { render, staticRenderFns } from "./sidemenuexample.vue?vue&type=template&id=2b310dc3&"
import script from "./sidemenuexample.vue?vue&type=script&lang=js&"
export * from "./sidemenuexample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports